import styles from "./Header.module.css";
import IconButton from "../components/IconButton";
import React, { FunctionComponent } from "react";
import classNames from "classnames";
import { TRootState } from "../store/create-store";
import { useDispatch, useSelector } from "react-redux";
import { rootActions } from "../reducers/root.slice";
import Icon from "../components/Icon";
import Link from "../components/Link";
import { LINK_TO_DOCS } from "../constants";
import { selectRightPanelState } from "../selectors";

type TProps = {};

const Header: FunctionComponent<TProps> = (props) => {
  const { rightPanelVisible } = useSelector(selectHeader);
  const dispatch = useDispatch();

  return (
    <header className={styles.header}>
      <a href="/" className={styles.logo}>
        <img src="/logo.svg" alt="logo" className={styles.logoImage} />
        Deep Representation Visualizer
      </a>

      <div className={styles.right}>
        <Link href={LINK_TO_DOCS} className={styles.headerLink} external>
          <Icon name="book" color="light" />
          <span className={styles.headerLinkText}>Documentation</span>
        </Link>

        <IconButton
          buttonClass={styles.rightPanelButton}
          name="menu_open"
          color="light"
          onClick={() => dispatch(rootActions.toggleRightPanel())}
          iconClass={classNames(styles.menuIcon, {
            [styles.rotate]: !rightPanelVisible,
          })}
        >
          {rightPanelVisible ? "Hide" : "Show"} right panel
        </IconButton>
      </div>
    </header>
  );
};

const selectHeader = (state: TRootState) => {
  return {
    rightPanelVisible: selectRightPanelState(state).visible,
  };
};

export default Header;
